import { Loader as MapsLoader } from '@googlemaps/js-api-loader';
import AnalyticsHelper from '../../utils/analytics-helper.js';

export default class DealerSearch {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.bas-search-location-wrapper');
        this.form = this.el.querySelector('form');
        this.input = this.el.querySelector('.bas-search-input');
        this.submit = this.el.querySelector('.bas-search-submit');
        this.filters = this.el.querySelector('.bas-search-filters');
        this.location = this.el.querySelector('.bas-search-location');
        this.background = parent.background;
        this.loader = parent.loader;
        this.results = parent.results;
        this.previous = {};
        this.autocomplete();
        this.currentLocation();
        this.bind();
        this.router.data.filter = this.filters.value;      
    }

    autocomplete() {
        if (this.input.dataset.autocomplete) {
            const mapsLoader = new MapsLoader({ apiKey: this.input.dataset.mapapikey, version: 'weekly', libraries: ['places'] });
            mapsLoader.load().then(() => {
                new google.maps.places.Autocomplete(this.input, { types: ['geocode', 'establishment'], componentRestrictions: { country: this.input.dataset.mapregion } });
            });
        }
    }

    currentLocation() {
        if (navigator.geolocation && location.protocol == 'https:') {
            this.location.addEventListener('click', (e) => {
                e.preventDefault();
                navigator.geolocation.getCurrentPosition((pos) => {
                    const lat = pos.coords.latitude;
                    const lng = pos.coords.longitude;
                    const value = `${lat} ${lng}`;

                    if (value !== this.router.params.get('query')) {
                        this.router.params.set('query', value);
                        this.router.update();
                    }
                });
            });
        } else {
            this.location.classList.add('hide');
        }
    }

    bind() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            const { value } = this.input;
            if (value !== this.router.params.get('query')) {                
                this.router.params.set('query', value);
                this.router.update();
            }
        });
    }

    show() {
        this.populate();
        this.search();
    }

    populate() {
        const query = this.router.params.get('query');
        this.input.value = query;
    }

    search() {
        const current = { query: this.router.params.get('query') };
        if (!current.query) {
            this.results.hide();
            this.background.show();
        } else if (_.isEqual(current, this.previous)) {
            this.results.show();
            this.background.hide();
        } else {
            this.results.hide();
            this.background.hide();
            this.loader.show();

            this.previous = current;
            fetch(this.form.action, { method: 'POST', body: new FormData(this.form) })
                .then((response) => response.json())
                .then((results) => this.results.render(current.query, results))
                .catch((error) => this.results.render(current.query));

            AnalyticsHelper.template(this.form, { query: this.router.params.get('query') });
            AnalyticsHelper.push(this.form);
        }
    }
}
